export function VirtualAppointmentDueBadge() {
    return (
        <span className="inline-flex items-center rounded-full border border-yellow-300 bg-yellow-50 px-1.5 py-px text-[10px] font-semibold text-yellow-700 whitespace-nowrap">
            Due
        </span>
    );
}
